


import { Tables } from '../../component/table'
import { useMemo } from 'react'
import { KTCard, toAbsoluteUrl } from '../../../_metronic/helpers'
import { useQueryResponseCount } from '../../component/response'
import { UserPurchaseWrapper } from './user-purchase'
import { getProjectByLocal } from '../projectData'

/**
 * CustomerTableHeader
 * Renders the header for the user purchase table, displays purchase banner and summary.
 */
const CustomerTableHeader = () => {
    const count = useQueryResponseCount()
    const project = getProjectByLocal()
    return <><div className='d-flex justify-content-between mb-10'>
        <img
            className="w-100"
            src={toAbsoluteUrl(`/media/images/${project?.purchase_banner}`)}
            alt=""
        />
    </div>


        <div className='d-flex gap-4'>

            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#71ae8d' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Total Qty</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.total_quantity ? count?.total_quantity : '0.00'}</span>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#8c63e2' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Total CashBack</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.total_points ? count?.total_points : '0.00'}</span>
                </div>
            </div>

            {/* <span className="badge badge-light-danger p-5 me-4 fs-6 text-dark fw-semibolder">Balance:
                {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.totalBalance ? count?.totalBalance : '0.00'}</span>}
            </span>
            <span className="badge badge-light-success p-5 me-4 fs-6 text-dark fw-semibolder"> Credit : {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.credit ? count?.credit : '0.00'}</span>}</span>
            <span className="badge badge-light p-5 me-4 fs-6 text-dark fw-semibolder"> Debit: {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.debit ? count?.debit : '0.00'}</span>}</span>
        */}
        </div >
    </>

}

/**
 * UserPurchaseList
 * Displays the user's purchase list in a table format.
 */
const UserPurchaseList = () => {


    const columns = useMemo(
        () => [
            {
                Header: (props) => {
                    return <th {...props.column.getHeaderProps()} >
                        <div className="d-flex flex-column">
                            <span className=""> Date </span>
                            <span className="">Txn No.</span>
                        </div>

                    </th>
                },
                id: 'created_at',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue">{row.original?.date} </div>
                            <div className="blue  text-danger text-capitalize">{row.original?.ref_key}</div>
                            {row.original?.sku_display_name &&
                                <div className="blue  text-success text-capitalize">{row.original?.sku_display_name}</div>
                            }
                        </>
                    );
                },
            },

            // {
            //     Header: (props) => {
            //         return <th {...props.column.getHeaderProps()} >
            //             <div className="d-flex flex-column">

            //                 <span className="">Txn No.</span>
            //             </div>

            //         </th>
            //     },
            //     id: 'trx_number',
            //     Cell: ({ row }) => {
            //         return (
            //             <>

            //                 <div className="blue  text-danger text-capitalize">{row.original?.ref_key}</div>

            //             </>
            //         );
            //     },
            // },
            {
                Header: 'Qty (ltr)',
                accessor: 'qty',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-success"> {row.original.quantity ? row.original?.quantity : '--'}</div>

                        </>
                    );
                },
            },
            {
                Header: 'Cashback',
                accessor: 'points',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-danger">

                                {row.original?.points ? row.original?.points : '--'}
                            </div>

                        </>
                    );
                },
            },
        ],
        []
    )

    return <UserPurchaseWrapper>
        <div className='mt-3 vh-100'>
            <KTCard>
                <CustomerTableHeader />
                <Tables columns={columns} />
            </KTCard>
        </div>
    </UserPurchaseWrapper>
}



export { UserPurchaseList }